const STYLES = {
  offen:      'bg-gray-100 text-gray-600',
  vermittelt: 'bg-blue-100 text-blue-700',
  geubt:      'bg-amber-100 text-amber-700',
  geprueft:   'bg-green-100 text-green-700',
  muss:       'bg-red-50 text-red-700',
  soll:       'bg-purple-50 text-purple-700',
};
const LABELS = {
  offen: 'offen', vermittelt: 'vermittelt', geubt: 'geübt', geprueft: 'geprüft',
  muss: 'muss', soll: 'soll',
};

export default function Badge({ type }) {
  return (
    <span className={`badge ${STYLES[type] ?? 'bg-gray-100 text-gray-500'}`}>
      {LABELS[type] ?? type}
    </span>
  );
}
